import { ApiPassException } from "@/types/api.types.ts";
import { QueryCache, QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
  queryCache: new QueryCache({
    onError: (error) => {
      if (error instanceof ApiPassException) {
        return;
      }
      // todo error handling
      // console.log("error in Query Cache", error);
      // toasts.showError({ title: "Error in request" });
    },
  }),
});
